import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../../../components/ui/card";
import { Separator } from "../../../../../components/ui/separator";
import { Skeleton } from "../../../../../components/ui/skeleton";
import {
  EntregoBaixaItem,
  EntregoOpsItem,
} from "../../fund-baixa-resolution/types";
import { ImileBaixaItemCard } from "./imile-baixa-item-card";
import { ImileOpsTable } from "./imile-ops-table";

interface ImileBaixaSectionProps {
  opsList: EntregoOpsItem[];
  baixaList: EntregoBaixaItem[];
  selectedOps: string[];
  onSelectionChange: (selectedOps: string[]) => void;
  isLoadingOps: boolean;
  isLoadingBaixas: boolean;
  onStartDoc: (filterDate: string, listOps: string[]) => void;
  onSubmitDb: (filterDate: string, listOps: string[]) => void;
  isStartingDoc: boolean;
  isSubmittingDb: boolean;
}

export function ImileBaixaSection({
  opsList,
  baixaList,
  selectedOps,
  onSelectionChange,
  isLoadingOps,
  isLoadingBaixas,
  onStartDoc,
  onSubmitDb,
  isStartingDoc,
  isSubmittingDb,
}: ImileBaixaSectionProps) {
  if (isLoadingOps) {
    return (
      <Card>
        <CardContent className="py-12">
          <div className="text-center space-y-4">
            <div className="flex justify-center">
              <Skeleton className="h-12 w-12 rounded-full" />
            </div>
            <Skeleton className="h-4 w-48 mx-auto" />
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <CardHeader className="px-0 pt-0">
        <CardTitle className="text-2xl">iMILE</CardTitle>
      </CardHeader>

      {opsList.length === 0 ? (
        <Card>
          <CardContent className="py-12">
            <div className="text-center">
              <CardTitle className="text-xl">
                Nenhuma base da iMile com crédito comprado a baixar
              </CardTitle>
              <p className="text-muted-foreground mt-2">
                A lista sai do cadastro de franquias, filtrada por crédito
                comprado e ainda não baixado.
              </p>
            </div>
          </CardContent>
        </Card>
      ) : (
        <ImileOpsTable
          opsList={opsList}
          selectedOps={selectedOps}
          onSelectionChange={onSelectionChange}
        />
      )}

      {selectedOps.length > 0 && (
        <>
          <Separator className="my-6" />

          {isLoadingBaixas ? (
            <Card>
              <CardContent className="py-12">
                <div className="text-center space-y-4">
                  <div className="flex justify-center">
                    <Skeleton className="h-12 w-12 rounded-full" />
                  </div>
                  <Skeleton className="h-4 w-56 mx-auto" />
                </div>
              </CardContent>
            </Card>
          ) : !Array.isArray(baixaList) || baixaList.length === 0 ? (
            <Card>
              <CardContent className="py-12">
                <div className="text-center">
                  <CardTitle className="text-xl">
                    Não há baixas de iMILE para serem finalizadas nas bases
                    selecionadas
                  </CardTitle>
                </div>
              </CardContent>
            </Card>
          ) : (
            <div className="space-y-4">
              {baixaList.map((baixa, index) => (
                <div key={`${baixa.data_romaneio}-${index}`}>
                  <ImileBaixaItemCard
                    baixaItem={baixa}
                    selectedOps={selectedOps}
                    onStartDoc={onStartDoc}
                    onSubmitDb={onSubmitDb}
                    isStartingDoc={isStartingDoc}
                    isSubmittingDb={isSubmittingDb}
                  />
                  {index < baixaList.length - 1 && (
                    <Separator className="my-4" />
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
